import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=29eb27e4&scoped=true"
import script from "./ReminderModal.vue?vue&type=script&lang=js"
export * from "./ReminderModal.vue?vue&type=script&lang=js"
import style0 from "./ReminderModal.vue?vue&type=style&index=0&id=29eb27e4&prod&scoped=true&lang=scss"
import style1 from "./ReminderModal.vue?vue&type=style&index=1&id=29eb27e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eb27e4",
  null
  
)

export default component.exports